/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Bio_WdInputs */

const en_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web Developer building responsive, accessible, and performant websites with modern tooling and clean code.`)
};

const ar_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور ويب يبني مواقع متجاوبة، متاحة، وعالية الأداء بأدوات حديثة وكود نظيف.`)
};

const bn_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওয়েব ডেভেলপার হিসেবে আধুনিক টুল ও পরিষ্কার কোড দিয়ে রেসপন্সিভ, অ্যাক্সেসিবল ও দ্রুত ওয়েবসাইট তৈরি করি।`)
};

const de_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webentwickler, der reaktionsfähige, zugängliche und leistungsstarke Websites mit modernen Tools und sauberem Code erstellt.`)
};

const es_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador web que crea sitios web receptivos, accesibles y de alto rendimiento con herramientas modernas y código limpio.`)
};

const fr_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur Web créant des sites Web réactifs, accessibles et performants avec des outils modernes et un code propre.`)
};

const pt_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor Web criando sites responsivos, acessíveis e de alto desempenho com ferramentas modernas e código limpo.`)
};

const zh_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web 开发人员使用现代工具和干净的代码构建响应灵敏、可访问且高性能的网站。`)
};

const tr_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern araçlar ve temiz kodla responsive, erişilebilir, performanslı siteler oluşturan Web Geliştiricisi.`)
};

const ru_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Веб-разработчик, создающий адаптивные, доступные и производительные веб-сайты с использованием современных инструментов и чистого кода.`)
};

const pl_resume_bio_wd = /** @type {(inputs: Resume_Bio_WdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programista stron internetowych tworzący responsywne, dostępne i wydajne strony internetowe przy użyciu nowoczesnych narzędzi i czystego kodu.`)
};

/**
* | output |
* | --- |
* | "Web Developer building responsive, accessible, and performant websites with modern tooling and clean code." |
*
* @param {Resume_Bio_WdInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_bio_wd = /** @type {((inputs?: Resume_Bio_WdInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Bio_WdInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_bio_wd(inputs)
	if (locale === "bn") return bn_resume_bio_wd(inputs)
	if (locale === "de") return de_resume_bio_wd(inputs)
	if (locale === "es") return es_resume_bio_wd(inputs)
	if (locale === "fr") return fr_resume_bio_wd(inputs)
	if (locale === "pt") return pt_resume_bio_wd(inputs)
	if (locale === "zh") return zh_resume_bio_wd(inputs)
	if (locale === "tr") return tr_resume_bio_wd(inputs)
	if (locale === "ru") return ru_resume_bio_wd(inputs)
	if (locale === "pl") return pl_resume_bio_wd(inputs)
	return en_resume_bio_wd(inputs)
});